/* eslint-disable no-prototype-builtins */
import { detach, types, getParent, getParentOfType, } from 'mobx-state-tree';
import { v4 } from 'uuid';
import schema, { generateType, updateFieldsGenerator } from './Schema';
import flattenSections from './flattenSections';
// Item Model
export const Item = generateType(schema.getModel('item') /* , overrideMap */)
    .views((self) => ({
    canHaveSubSections() {
        return self.item === null;
    },
    canHaveItems() {
        return self.item == null;
        // section.sections == null || section.sections.length === 0;
    },
    canDelete() {
        return (!self.sections || self.sections.length === 0);
    },
    flattenSections() {
        return flattenSections(self);
    },
    filterSections(type) {
        return this.flattenSections().filter((section) => section.type === type);
    },
}))
    .actions((self) => ({
    /**
     * Moves a section to a new location in the Program tree.
     *
     * @param sectionToMove
     * @param target
     * @param index
     */
    /**
     * Returns the subSection from the section and returns it.
     * Section is matched by ID.
     * @param subSection
     */
    removeSubSection(toRemove) {
        detach(toRemove);
        self.addChange();
    },
    insertSubSection(subSection, atIndex) {
        if (atIndex < 0) {
            self.sections.push(subSection);
        }
        else {
            self.sections.splice(atIndex, 0, subSection);
        }
        self.addChange();
    },
    updateValues(values) {
        // takes a bunch of values and updates this instance with them
        if (!values) {
            return;
        }
        Object.keys(values).forEach((key) => {
            // MST forbids changing identifiers - never update key or id via updateValues
            if (key === 'key' || key === 'id')
                return;
            if (self.hasOwnProperty(key))
                self[key] = values[key];
        });
        self.addChange();
    },
    setInstuctorNames() {
        let searchInstructors = '';
        if (self.instructors && self.instructors.length) {
            self.instructors.forEach((instructor) => {
                // console.log(instructor);
                searchInstructors += `${instructor.name},`;
            });
        }
        self.searchInstructors = searchInstructors;
    },
    setCourseItems() {
        self.courseItems = self
            .filterSections('course')
            .map((section) => (section?.item?.course?.key))
            .filter(Boolean)
            .join(',');
    },
    setMicrocastItems() {
        self.microcastItems = self
            .filterSections('microcast')
            .map((section) => (section?.item?.microcast?.key))
            .filter(Boolean)
            .join(',');
    },
    addLibrary(library) {
        self.libraries.push(library);
    },
    removeLibrary(library) {
        self.libraries.remove(library);
    },
}));
// ItemItem
export const ItemItem = generateType(schema.getModel('learningItemCommon') /* , overrideMap */);
// ItemSection Model
export const ItemSection = types.model({
    id: types.identifier,
    name: types.string,
    // parts: types.array(types.union(
    //   types.late((): IAnyModelType => CourseSection),
    //   types.late(() => CourseLesson)
    // ))
    sections: types.optional(types.array(types.late(() => ItemSection)), []),
    type: types.enumeration('SectionType', ['block', 'video', 'audio', 'quiz', 'article', 'pdf', 'download', 'container', 'course', 'scorm', 'html', 'knowledgeCheck', 'microcast', 'certification', 'typeform']),
    description: types.optional(types.string, ''),
    item: types.maybeNull(ItemItem),
    hidden: types.optional(types.boolean, false),
})
    .views((self) => ({
    /**
     *
     * @returns the parent of this section - either the course if its top level
     * or the section that contains this one.
     */
    getParent() {
        return getParent(self, 2);
    },
    canHaveSubSections() {
        return self.item === null;
    },
    canHaveItems() {
        return self.item == null;
        // section.sections == null || section.sections.length === 0;
    },
    canDelete() {
        return (!self.sections || self.sections.length === 0);
    },
}))
    .actions((self) => ({
    addChange() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getParentOfType(self, Item).addChange();
    },
    /**
     * Returns the subSection from the section and returns it.
     * Section is matched by ID.
     * @param subSection
     */
    removeSubSection(toRemove) {
        detach(toRemove);
        this.addChange();
    },
    /**
     * Adds a subsection into a section at the specified index.  If index is negative
     * it is added at the end.
     * @param subSection
     * @param atIndex
     */
    insertSubSection(subSection, atIndex) {
        if (atIndex < 0) {
            self.sections.push(subSection);
        }
        else {
            self.sections.splice(atIndex, 0, subSection);
        }
        this.addChange();
    },
    updateFields: updateFieldsGenerator(self),
}));
export const getNewItem = (name, type) => {
    const item = {
        id: v4(),
        type,
        level: 'beginner',
    };
    if (type === 'quiz' || type === 'knowledgeCheck') {
        const answerValue = v4();
        item.questions = [{
                id: v4(),
                type: 'multipleChoiceQuestion',
                questionText: '',
                answers: [
                    {
                        id: answerValue,
                        answerText: '',
                    },
                    {
                        id: v4(),
                        answerText: '',
                    },
                ],
                correctAnswer: [answerValue],
            }];
    }
    return item;
};
//# sourceMappingURL=ItemModel.js.map